import { motion } from "framer-motion";
import styled from "styled-components";
import { fill } from "../styles/utils";

interface CircularMotionProps {
  radius?: number;
  duration?: number;
  isAnimating?: boolean;
}

const Wrapper = styled(motion.div)`
  position: relative;
  height: 100%;
`;

export const CircularMotion: React.FC<CircularMotionProps> = ({
  children,
  radius = 32,
  duration = 16,
  isAnimating = false,
}) => {
  return (
    <Wrapper
      initial={{ rotate: 0 }}
      animate={isAnimating ? { rotate: 360 } : { rotate: 0 }}
      transition={{ duration, repeat: Infinity, ease: "linear" }}
    >
      <Wrapper style={{ y: radius }}>
        <Wrapper
          id="x"
          initial={{ rotate: 0 }}
          animate={isAnimating ? { rotate: -360 } : { rotate: 0 }}
          transition={{ duration, repeat: Infinity, ease: "linear" }}
        >
          {children}
        </Wrapper>
      </Wrapper>
    </Wrapper>
  );
};
